import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { Calculation } from './Calculation.entity';
import { Contract } from './Contract.entity';
import { DeliveryNote } from './DeliveryNote.entity';
import { Demand } from './Demand.entity';
import { InboundDeliveryNote } from './InboundDeliveryNote.entity';
import { Invoice } from './Invoice.entity';
import { Offer } from './Offer.entity';
import { Order } from './Order.entity';
import { ShadowBzObject } from './ShadowBzObject.entity';
import { ValidationMessage } from './ValidationMessage.entity';

export class BillProjectHoursResult<T extends EMode = EMode.entity> {
  /** Alias: errors */
  errors?: ValidationMessage<T>[];
  /** Alias: warnings */
  warnings?: ValidationMessage<T>[];
  /** Alias: createdBzObjectCodes */
  createdBzObjectCodes?: number[];
  /** Alias: dryRunBzObject */
  dryRunBzObject?: T extends EMode.query
    ? ShadowBzObject<T>
    :
        | Calculation<T>
        | Offer<T>
        | Contract<T>
        | Invoice<T>
        | DeliveryNote<T>
        | Demand<T>
        | Order<T>
        | InboundDeliveryNote<T>;
  /** Alias: totalBzObjectCount */
  totalBzObjectCount?: number;

  __typename?: string;
}

const fields: FieldDefinitions<BillProjectHoursResult> = {
  errors: {
    alias: 'errors',
    entity: Entities.validationMessage,
  },
  warnings: {
    alias: 'warnings',
    entity: Entities.validationMessage,
  },
  createdBzObjectCodes: {
    alias: 'createdBzObjectCodes',
  },
  dryRunBzObject: {
    alias: 'dryRunBzObject',
    entity: [
      Entities.calculation,
      Entities.offer,
      Entities.contract,
      Entities.invoice,
      Entities.deliveryNote,
      Entities.demand,
      Entities.order,
      Entities.inboundDeliveryNote,
    ],
  },
  totalBzObjectCount: {
    alias: 'totalBzObjectCount',
  },
  __typename: {
    alias: '__typename',
  },
};

export const billProjectHoursResultEntityDefinition: EntitiyDefinition<BillProjectHoursResult> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'BillProjectHoursResult',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'billProjectHours',
          args: [
            { name: 'filters', type: 'BillProjectHoursRequestFilter!' },
            { name: 'settings', type: 'BillProjectHoursRequestSettings!' },
          ],
        },
      },
    },
    fieldDefinitions: fields,
  };
